import React, { useState, useEffect } from "react"
import {
    Container,
    Row,
    Col,
    Card,
    CardBody,
    CardTitle,
    Form,
    FormGroup,
    Label,
    Input,
    Button,
} from "reactstrap"
import { connect } from "react-redux"
import { setBreadcrumbItems } from "../../store/actions"
import { toast } from "react-toastify"

const UserProfile = (props) => {
    document.title = "Mon Profil | CRM"

    const breadcrumbItems = [
        { title: "CRM", link: "#" },
        { title: "Mon Profil", link: "#" },
    ]

    useEffect(() => {
        props.setBreadcrumbItems("Mon Profil", breadcrumbItems)
    }, [])

    const getUserFromLocalStorage = () => {
        const authUser = localStorage.getItem('authUser')
        if (authUser) {
            try {
                const parsed = JSON.parse(authUser)
                return parsed?.user || parsed
            } catch (e) {
                return null
            }
        }
        return null
    }

    const user = getUserFromLocalStorage()

    const [formData, setFormData] = useState({
        first_name: user?.first_name || '',
        last_name: user?.last_name || '',
        email: user?.email || '',
        phone: user?.phone || '',
    })

    const [passwordData, setPasswordData] = useState({
        current_password: '',
        new_password: '',
        new_password_confirmation: '',
    })

    const handleInputChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        })
    }

    const handlePasswordChange = (e) => {
        setPasswordData({
            ...passwordData,
            [e.target.name]: e.target.value
        })
    }

    const handleSubmit = (e) => {
        e.preventDefault()
        // TODO: API call to update profile
        toast.success("Profil mis à jour avec succès")
    }

    const handlePasswordSubmit = (e) => {
        e.preventDefault()
        if (passwordData.new_password !== passwordData.new_password_confirmation) {
            toast.error("Les mots de passe ne correspondent pas")
            return
        }
        // TODO: API call to change password
        toast.success("Mot de passe modifié avec succès")
        setPasswordData({
            current_password: '',
            new_password: '',
            new_password_confirmation: '',
        })
    }

    const firstName = user?.first_name || ''
    const lastName = user?.last_name || ''
    const firstInitial = firstName.charAt(0).toUpperCase()
    const lastInitial = lastName.charAt(0).toUpperCase()
    const userInitials = `${firstInitial}${lastInitial}` || 'U'

    return (
        <React.Fragment>
            <div className="container-fluid">
                <Row>
                    <Col lg="4">
                        <Card>
                            <CardBody>
                                <div className="text-center mb-4">
                                    <div
                                        className="rounded-circle d-inline-flex align-items-center justify-content-center mx-auto"
                                        style={{
                                            width: '100px',
                                            height: '100px',
                                            backgroundColor: '#556ee6',
                                            color: 'white',
                                            fontWeight: '600',
                                            fontSize: '36px'
                                        }}
                                    >
                                        {userInitials}
                                    </div>
                                    <h5 className="mt-3 mb-1">{firstName} {lastName}</h5>
                                    <p className="text-muted mb-0">{user?.email}</p>
                                    {user?.user_type && (
                                        <span className="badge bg-primary mt-2">
                                            {user.user_type === 'system' ? 'Administrateur Système' : 'Utilisateur Entreprise'}
                                        </span>
                                    )}
                                </div>

                                <hr />

                                <div className="mt-4">
                                    <h6 className="font-size-14 mb-3">Informations</h6>
                                    <div className="table-responsive">
                                        <table className="table table-sm table-borderless mb-0">
                                            <tbody>
                                                <tr>
                                                    <td className="text-muted">Email :</td>
                                                    <td className="fw-medium">{user?.email || '-'}</td>
                                                </tr>
                                                <tr>
                                                    <td className="text-muted">Téléphone :</td>
                                                    <td className="fw-medium">{user?.phone || '-'}</td>
                                                </tr>
                                                <tr>
                                                    <td className="text-muted">Statut :</td>
                                                    <td>
                                                        <span className={`badge ${user?.status === 'active' ? 'bg-success' : 'bg-danger'}`}>
                                                            {user?.status === 'active' ? 'Actif' : 'Inactif'}
                                                        </span>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>

                    <Col lg="8">
                        <Card>
                            <CardBody>
                                <CardTitle className="h4 mb-4">Modifier le Profil</CardTitle>
                                <Form onSubmit={handleSubmit}>
                                    <Row>
                                        <Col md="6">
                                            <FormGroup className="mb-3">
                                                <Label for="first_name">Prénom</Label>
                                                <Input
                                                    type="text"
                                                    id="first_name"
                                                    name="first_name"
                                                    value={formData.first_name}
                                                    onChange={handleInputChange}
                                                    placeholder="Prénom"
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md="6">
                                            <FormGroup className="mb-3">
                                                <Label for="last_name">Nom</Label>
                                                <Input
                                                    type="text"
                                                    id="last_name"
                                                    name="last_name"
                                                    value={formData.last_name}
                                                    onChange={handleInputChange}
                                                    placeholder="Nom"
                                                />
                                            </FormGroup>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col md="6">
                                            <FormGroup className="mb-3">
                                                <Label for="email">Email</Label>
                                                <Input
                                                    type="email"
                                                    id="email"
                                                    name="email"
                                                    value={formData.email}
                                                    onChange={handleInputChange}
                                                    placeholder="Email"
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md="6">
                                            <FormGroup className="mb-3">
                                                <Label for="phone">Téléphone</Label>
                                                <Input
                                                    type="text"
                                                    id="phone"
                                                    name="phone"
                                                    value={formData.phone}
                                                    onChange={handleInputChange}
                                                    placeholder="Téléphone"
                                                />
                                            </FormGroup>
                                        </Col>
                                    </Row>

                                    <div className="text-end">
                                        <Button type="submit" color="primary">
                                            <i className="mdi mdi-content-save me-1"></i>
                                            Enregistrer
                                        </Button>
                                    </div>
                                </Form>
                            </CardBody>
                        </Card>

                        <Card>
                            <CardBody>
                                <CardTitle className="h4 mb-4">Changer le Mot de Passe</CardTitle>
                                <Form onSubmit={handlePasswordSubmit}>
                                    <FormGroup className="mb-3">
                                        <Label for="current_password">Mot de passe actuel</Label>
                                        <Input
                                            type="password"
                                            id="current_password"
                                            name="current_password"
                                            value={passwordData.current_password}
                                            onChange={handlePasswordChange}
                                            placeholder="••••••••"
                                        />
                                    </FormGroup>

                                    <Row>
                                        <Col md="6">
                                            <FormGroup className="mb-3">
                                                <Label for="new_password">Nouveau mot de passe</Label>
                                                <Input
                                                    type="password"
                                                    id="new_password"
                                                    name="new_password"
                                                    value={passwordData.new_password}
                                                    onChange={handlePasswordChange}
                                                    placeholder="••••••••"
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md="6">
                                            <FormGroup className="mb-3">
                                                <Label for="new_password_confirmation">Confirmer le mot de passe</Label>
                                                <Input
                                                    type="password"
                                                    id="new_password_confirmation"
                                                    name="new_password_confirmation"
                                                    value={passwordData.new_password_confirmation}
                                                    onChange={handlePasswordChange}
                                                    placeholder="••••••••"
                                                />
                                            </FormGroup>
                                        </Col>
                                    </Row>

                                    <div className="text-end">
                                        <Button type="submit" color="warning">
                                            <i className="mdi mdi-lock-reset me-1"></i>
                                            Changer le Mot de Passe
                                        </Button>
                                    </div>
                                </Form>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>
        </React.Fragment>
    )
}

export default connect(null, { setBreadcrumbItems })(UserProfile)
